<script>
  export default {
    props: {
      currentPage: {
        type: Number,
        required: true
      },
      pageCount: {
        type: Number,
        required: true
      },
      visiblePages: {
        type: Number,
        default: 3
      }
    },
    data () {
      return {
        innerValue: 1
      }
    },
    computed: {
      selected: {
        get () {
          return this.currentPage || this.innerValue
        },
        set (val) {
          this.innerValue = val
        }
      },
      paginationListAlt () {
        const itemsArr = Array(this.visiblePages - 1).fill(0)
        let items = []
        const halfRange = Math.floor(this.visiblePages / 2)
        if (this.currentPage <= halfRange) {
          items = itemsArr.map((item, i) => {
            return {
              index: i,
              content: i + 1,
              selected: this.selected === i + 1
            }
          })
          items.push({
            index: this.pageCount - 1,
            content: this.pageCount,
            selected: this.selected === this.pageCount
          })
          return items
        }
        if (this.currentPage >= this.pageCount - halfRange + 1) {
          items = itemsArr.map((item, i) => {
            return {
              index: this.pageCount - i - 1,
              content: this.pageCount - i,
              selected: this.selected === this.pageCount - i
            }
          })
          items.reverse().unshift({
            index: 0,
            content: 1,
            selected: this.selected === 1
          })
          return items
        }
        items = itemsArr.map((item, i) => {
          return {
            index: this.currentPage - halfRange + i,
            content: this.currentPage - halfRange + i + 1,
            selected: this.selected === this.currentPage - halfRange + i + 1
          }
        })
        items.unshift({
          index: 0,
          content: 1,
          selected: this.selected === 1
        })
        items[items.length - 1] = {
          index: this.pageCount - 1,
          content: this.pageCount,
          selected: this.selected === this.pageCount
        }
        return items
      },
      paginationList () {
        const items = {}
        const setPage = (index) => {
          items[index] = {
            index,
            content: index + 1,
            selected: index + 1 === this.selected
          }
        }
        // + 2 = first and last item
        if (this.pageCount <= this.visiblePages + 2) {
          for (let i = 0; i < this.pageCount; i++) {
            setPage(i)
          }
        } else {
          const setBreakView = (index) => {
            const breakView = {
              disabled: true,
              breakView: true
            }
            items[index] = breakView
          }

          // set first item
          setPage(0)

          const halfRange = Math.floor(this.visiblePages / 2)
          let rangeLow = 1

          if (this.selected > halfRange) {
            rangeLow = this.selected - 1 - halfRange
          }
          if (this.selected === halfRange + 1 || this.selected === this.pageCount - halfRange) {
            rangeLow = this.selected - 1
          }
          let rangeHigh = rangeLow + this.visiblePages - 1
          if (rangeHigh >= this.pageCount) {
            rangeHigh = this.pageCount - 1
            rangeLow = rangeHigh - this.visiblePages
          }

          // set range items
          for (let i = rangeLow; i <= rangeHigh && i <= this.pageCount - 1; i++) {
            setPage(i)
          }

          // Check if there is breakView in the left of selected range
          if (rangeLow > 1) {
            setBreakView(rangeLow - 1)
          }
          // Check if there is breakView in the right of selected range
          if (rangeHigh + 1 < this.pageCount - 1) {
            setBreakView(rangeHigh + 1)
          }

          // set last item
          setPage(this.pageCount - 1)
        }
        return items
      }
    },
    methods: {
      handlePageSelect (page) {
        if (this.selected === page) return
        this.innerValue = page
        this.$emit('update', page)
      },
      prevPage () {
        if (this.selected <= 1) return
        this.handlePageSelect(this.selected - 1)
      },
      nextPage () {
        if (this.selected >= this.pageCount) return
        this.handlePageSelect(this.selected + 1)
      }
    }
  }
</script>

<template>
  <div class="pagination-base flex">
    <e-button
      type="secondary"
      class="mr-2"
      :disabled="currentPage === 1"
      @click="prevPage"
    >
      <q-icon name="arrow-left" />
    </e-button>
    <ul class="flex items-center">
      <li
        v-for="page in paginationList"
        :key="page.index"
        class="mr-2"
      >
        <span v-if="page.breakView">
          ...
        </span>
        <e-button
          v-else
          type="secondary"
          :class="{'is-active': page.selected}"
          @click="handlePageSelect(page.index + 1)"
        >
          {{ page.content }}
        </e-button>
      </li>
    </ul>
    <e-button
      type="secondary"
      :disabled="currentPage + 1 > pageCount"
      @click="nextPage"
    >
      <q-icon name="arrow-right" />
    </e-button>
  </div>
</template>

<style lang="scss" scoped>

  .button-secondary {
    @apply w-12;

    &.is-active {
      box-shadow: inset 0 0 0 0.125rem theme('colors.black');
    }

  }

</style>
